import * as http from '~/utils/apis';

const uploadImage = async (values, pictureAttributeNames, type) => {

    for(let pictureAttributeName of pictureAttributeNames) {
        try {
            let data = new FormData();
            data.append('image', values[pictureAttributeName]);
            data.append('type', type);
            let suffix = pictureAttributeName.replace(/[A-Z]/g, str => '_' + str).toUpperCase()
            data.append('name', `${values.id}-${suffix}.png`);
        
            let res = await http.post(`upload-image`, data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            console.log(res);
        }
        catch{}
    }
};

export default uploadImage;
